import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";

type FieldVisibility = "public" | "internal" | "not-applicable";

type FieldVisibilityIconProps = {
  variant: FieldVisibility;
  label: string;
};

export const FieldVisibilityIcon = ({ variant, label }: FieldVisibilityIconProps) => {
  const Icon = variant === "public" ? FaRegEye : FaRegEyeSlash;
  const className = variant === "public"
    ? "field-visibility-icon is-public"
    : "field-visibility-icon is-internal";

  return (
    <span className={className} title={label} aria-label={label}>
      <Icon />
    </span>
  );
};

export const PublicFieldVisibilityIcon = ({ label }: { label: string }) => (
  <FieldVisibilityIcon variant="public" label={label} />
);

export const InternalFieldVisibilityIcon = ({ label }: { label: string }) => (
  <FieldVisibilityIcon variant="internal" label={label} />
);

export type { FieldVisibility };
